// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  destinationRequest: null,
  destinationSuccess: ['data'],
  destinationFailure: ['err'],

  destinationCreateRequest: ['data'],
  destinationCreateSuccess: ['data'],
  destinationCreateFailure: ['err'],

  destinationDeleteRequest: ['data'],
  destinationDeleteSuccess: ['data'],
  destinationDeleteFailure: ['err'],

  destinationUpdateRequest: ['data'],
  destinationUpdateSuccess: ['data'],
  destinationUpdateFailure: ['err'],

  addAttractionToDestinationRequest: ['data'],
  addAttractionToDestinationSuccess: ['data'],
  addAttractionToDestinationFailure: ['err'],

  deleteAttractionFromDestinationRequest: ['data'],
  deleteAttractionFromDestinationSuccess: ['data'],
  deleteAttractionFromDestinationFailure: ['err'],

  addPlaceToDestinationRequest: ['data'],
  addPlaceToDestinationSuccess: ['data'],
  addPlaceToDestinationFailure: ['err'],

  deletePlaceFromDestinationRequest: ['data'],
  deletePlaceFromDestinationSuccess: ['data'],
  deletePlaceFromDestinationFailure: ['err'],

  continentRequest: null,
  continentSuccess: ['data'],
  continentFailure: ['err'],
})

export const DestinationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  continent: [],
  err: null,
  processing: false,
  success: null,
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const continentSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    continent: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.DESTINATION_SUCCESS]: success,
  [Types.DESTINATION_REQUEST]: request,
  [Types.DESTINATION_FAILURE]: failure,

  [Types.DESTINATION_CREATE_REQUEST]: manipulateRequest,
  [Types.DESTINATION_CREATE_SUCCESS]: manipulateSuccess,
  [Types.DESTINATION_CREATE_FAILURE]: manipulateFailure,

  [Types.DESTINATION_DELETE_REQUEST]: manipulateRequest,
  [Types.DESTINATION_DELETE_SUCCESS]: manipulateSuccess,
  [Types.DESTINATION_DELETE_FAILURE]: manipulateFailure,

  [Types.DESTINATION_UPDATE_REQUEST]: manipulateRequest,
  [Types.DESTINATION_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.DESTINATION_UPDATE_FAILURE]: manipulateFailure,

  [Types.ADD_ATTRACTION_TO_DESTINATION_REQUEST]: manipulateRequest,
  [Types.ADD_ATTRACTION_TO_DESTINATION_SUCCESS]: manipulateSuccess,
  [Types.ADD_ATTRACTION_TO_DESTINATION_FAILURE]: manipulateFailure,

  [Types.DELETE_ATTRACTION_FROM_DESTINATION_REQUEST]: manipulateRequest,
  [Types.DELETE_ATTRACTION_FROM_DESTINATION_SUCCESS]: manipulateSuccess,
  [Types.DELETE_ATTRACTION_FROM_DESTINATION_FAILURE]: manipulateFailure,

  [Types.ADD_PLACE_TO_DESTINATION_REQUEST]: manipulateRequest,
  [Types.ADD_PLACE_TO_DESTINATION_SUCCESS]: manipulateSuccess,
  [Types.ADD_PLACE_TO_DESTINATION_FAILURE]: manipulateFailure,

  [Types.DELETE_PLACE_FROM_DESTINATION_REQUEST]: manipulateRequest,
  [Types.DELETE_PLACE_FROM_DESTINATION_SUCCESS]: manipulateSuccess,
  [Types.DELETE_PLACE_FROM_DESTINATION_FAILURE]: manipulateFailure,

  [Types.CONTINENT_SUCCESS]: continentSuccess,
  [Types.CONTINENT_REQUEST]: request,
  [Types.CONTINENT_FAILURE]: failure,
})



// WEBPACK FOOTER //
// ./src/Redux/DestinationRedux.js